import type { ReactNode } from "react";
import { useAo3InView } from "@/hooks/ao3UseInView";

interface Ao3RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export default function Ao3Reveal({ children, className = "", delay = 0 }: Ao3RevealProps) {
  const { ref, inView } = useAo3InView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}